// extracted by mini-css-extract-plugin
module.exports = {"container":"entity_breadcrumbs_container-module__container--3cp89","textContainer":"entity_breadcrumbs_container-module__textContainer--20MG_"};